import { FC, PropsWithChildren } from 'react';
import { createUseThemedStyles } from '@/hooks';

const useTableBodyStyles = createUseThemedStyles({
	tableBody: {},
});

export const TableBody: FC<PropsWithChildren> = ({ children }) => {
	const classes = useTableBodyStyles();

	return <tbody className={classes.tableBody}>{children}</tbody>;
};
